import PengaturanDimensi from "../../../../../components/categories/siakad/laporan_adab/pengaturan_dimensi/Home";
export default function Home() {
  
  return (
    <PengaturanDimensi />
  );
}
